import { render, staticRenderFns } from "./BedSolid.vue?vue&type=template&id=d975a6a0&"
import script from "./BedSolid.vue?vue&type=script&lang=ts&"
export * from "./BedSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports